import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { UsersListService } from '@admin-panel/infra';
import { SetModerationFlagRequestDtoFlag, SetUserModerationFlagBody } from '@core-http';
import { SetUserModerationFlagCommandPayload } from './set-user-moderation-flag.command-payload';

export class SetUserModerationFlagCommandHandler {
  private readonly usersListService: UsersListService = inject(UsersListService);

  setFlag(payload: SetUserModerationFlagCommandPayload): Observable<void> {
    const body: SetUserModerationFlagBody = {
      flag: payload.flag,
      value: payload.value,
      comment: payload.comment,
      ...this.buildBanReason(payload)
    };

    return this.usersListService.setModerationFlag({ userId: payload.userId }, body);
  }

  private buildBanReason(payload: SetUserModerationFlagCommandPayload): { banReason?: string } {
    const isBanning: boolean = payload.flag === SetModerationFlagRequestDtoFlag.BANNED && payload.value;

    return isBanning && payload.banReason ? { banReason: payload.banReason } : {};
  }
}
